import { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { SelectControl } from 'components/forms/Select';
import { DISTANCE_NAME } from 'components/searchAds/constants';

export default class ModelControl extends PureComponent {
  static propTypes = {
    onChanged: PropTypes.func,
    input: PropTypes.object,
  };

  onModelChange = (distance) => {
    const { input } = this.props;

    input.onChange({
      ...input.value,
      [DISTANCE_NAME]: distance,
    });
  };

  onModelBlur = (distance) => {
    const { input } = this.props;

    input.onBlur({ ...input.value, [DISTANCE_NAME]: distance });
  };

  render() {
    const { input } = this.props;
    const {
      value: { distance },
    } = input;

    return (
      <SelectControl
        {...this.props}
        input={{
          ...input,
          value: distance,
          onChange: this.onModelChange,
          onBlur: this.onModelBlur,
        }}
      />
    );
  }
}
